import { HttpModule } from "../http";
import type { Module } from "@webmotors/ioc";

import { TokenService } from "./token.service";
import { LoggerModule } from "../logger";

export const TokenModule: Module = {
  name: "TokenModule",
  modules: [HttpModule, LoggerModule],
  providers: [TokenService],
};
